import axios from 'axios'

function unwrap (resp, message) {
  if (resp && resp.code === 200) {
    return resp.data
  }
  throw new Error((resp && resp.message) || message)
}

export default {
  async loadCategories () {
    const { data: resp } = await axios.get('/spine/science/category/list')
    return unwrap(resp, '加载科普分类失败')
  },
  async loadArticles (categoryKey) {
    const { data: resp } = await axios.get('/spine/science/article/list', { params: { categoryKey } })
    return unwrap(resp, '加载科普文章失败')
  },
  async loadArticle (id) {
    const { data: resp } = await axios.get('/spine/science/article/load', { params: { id } })
    return unwrap(resp, '加载科普文章详情失败')
  }
}
